import styled from "styled-components";

const useResolveColorTheme = ({ light, dark }) => {
  return dark;
};

export const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  margin: 10px;
  background-color: #d9d9d9;
  border-radius: 10px;
  padding: 10px;
  font-size: 1rem;
  font-weight: 100;
  border-left: 4px solid green;
`;

export const ServerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: 3px solid #437971;
  padding-bottom: 10px;
`;

export const ServerName = styled.div`
  font-weight: 600;
  font-size: 1.2rem;
  color: ${(props) => props.color};
`;

export const ServerDomain = styled.div`
  font-size: 0.8rem;
  color: #000;
  margin-top: 3px;
`;

export const ServerStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 300;
  /* color: black; */
`;

export const ServerStatusHeader = styled.div`
  /* display: flex; */
  flex-direction: column;
  /* justify-content: center; */
  align-items: flex-start;
  margin: 0px 0px 0px 0px;
  font-size: 1rem;
  font-weight: 800;
`;

export const ServerStatusOnline = styled.div`
  /* padding: 3px; */
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
  /* font-weight: 600; */
  background-color: green;
  color: #fff;
`;

export const ServerStatusOffline = styled.div`
  /* display: flex;
  justify-content: center;
  align-items: center; */
  /* padding: 3px; */
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
  background-color: red;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
  font-size: 0.75rem;
`;

export const InfoLabel = styled.span`
  font-weight: 500;
  color: #000;
`;

export const InfoValue = styled.span`
  color: ${(props) => (props.color ? props.color : "#000")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "normal")};
`;

export const DashboardGridQrCode = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  margin: 10px;
  background-color: #fff;
  /* border-radius: 10px; */
  padding: 10px;
  font-size: 1rem;
  font-weight: 100;
  /* border-left: 4px solid green; */
`;

export const QrCodeRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const QrCodeLabel = styled.div`
  font-weight: 600;
  font-size: 1.2rem;
  color: ${(props) => props.color};
  text-align: center;
`;
